import {
  MEASURETOOL_SET_PIXELS,
  DEBUGING_TOOL_MOVED,
  APPTOOLBAR_RESET_APP_STATE
} from "../lib/types";

const initialState = {
  x: 0,
  y: 0,
  measureToolPixels: 0
};

export default (state = initialState, action) => {
  /* discriminate the action type */
  switch (action.type) {
    case DEBUGING_TOOL_MOVED:
      return {
        ...state,
        x: action.payload.x,
        y: action.payload.y
      };
    case MEASURETOOL_SET_PIXELS:
      return {
        ...state,
        measureToolPixels: action.payload
      };
    case APPTOOLBAR_RESET_APP_STATE:
      return initialState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/debuging-tool-reducer.js